<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :color="
      $vuetify.theme.dark
        ? 'dark_backgroundBlack'
        : 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'
    "
    :right="$vuetify.rtl"
    mobile-breakpoint="960"
    :mini-variant="miniVariant"
    mini-variant-width="90"
    app
    width="180"
    v-bind="$attrs"
    touchless
  >
    <template v-slot:prepend>
      <v-list dense nav class="mt-1">
        <v-list-item class="ml-0 pl-0">
          <template v-if="miniVariant">
            <v-avatar
              size="50"
              :color="$vuetify.theme.dark ? 'dark_backgroundLighterBlack' : 'softBackgroundGrey'"
              class="ml-2"
            >
              <img :src="require(`@/assets/logo/logo.svg`)" class="pa-1" />
            </v-avatar>
          </template>

          <v-list-item-content>
            <v-list-item-title>
              <img :src="require(`@/assets/logo/logo.svg`)" width="90px" class="ml-3" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <v-list nav class="py-0 pt-1">
      <template v-for="(item, idx) in items">
        <template
          v-if="
            (!item.countryFilter || item.countryFilter.indexOf(user.country) > -1) &&
            (!item.baseCurrencyFilter || item.baseCurrencyFilter.indexOf(user.baseCurrency) > -1)
          "
        >
          <v-list-group
            v-if="item.children"
            :key="idx"
            v-model="item.active"
            :prepend-icon="item.icon"
            append-icon="mdi-menu-down"
            color="grey darken-1"
            class="my-1"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ $t(`drawer.title.${item.title}`) }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="child in item.children">
              <v-list-item
                v-if="
                  (!child.countryFilter || child.countryFilter.indexOf(user.country) > -1) &&
                  (!child.baseCurrencyFilter ||
                    child.baseCurrencyFilter.indexOf(user.baseCurrency) > -1)
                "
                :key="child.title"
                :to="child.to"
                class="ml-2 mb-0"
              >
                <v-list-item-icon>
                  <v-icon size="20" v-text="child.icon" />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ $t(`drawer.title.${child.title}`) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item v-else :key="idx" :to="item.to" class="my-1">
            <v-list-item-icon>
              <v-icon size="21" v-text="item.icon" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t(`drawer.title.${item.title}`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>

    <template v-slot:append>
      <!-- <v-divider class="my-1 mx-3" /> -->
      <v-list nav class="list-drawer-bottom pb-1 pt-2">
        <v-list-item key="brokerAccounts" to="/accounts" class="my-0">
          <v-list-item-icon>
            <v-icon size="21">mdi-bank</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(`drawer.title.brokerAccounts`) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <div @click.prevent="doLogout">
          <base-item
            :item="{
              title: $t('appBar.title.logout'),
              icon: 'mdi-logout',
            }"
          />
        </div> -->

        <v-list-item v-if="supplantedUser">
          <v-chip color="primary">
            {{ supplantedUser.email }}
          </v-chip>

          <v-tooltip top max-width="300px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-1" v-bind="attrs" v-on="on" @click="stopSupplantUser">
                mdi-close
              </v-icon>
            </template>
            <span>Stop supplanting</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item to="/account" class="user-account my-0">
          <div :class="{ 'user-account-avatar': !miniVariant }">
            <UserAvatar :show-display-name="false" size="30" />
          </div>

          <v-list-item-content>
            <v-list-item-title>
              <span class="user-account-display-name ml-2">
                {{ displayOnlyFirstName }}
              </span>
              <v-icon
                v-if="['PLAN_PREMIUM'].indexOf(user.status) > -1"
                class="user-account-display-premium"
                size="16"
                color="softTextGrey"
              >
                mdi-rocket
              </v-icon>
              <v-icon
                v-if="['PLAN_PRO'].indexOf(user.status) > -1"
                class="user-account-display-pro"
                size="15"
                color="softTextGrey"
              >
                mdi-rocket-launch
              </v-icon>
              <v-icon
                v-if="['PLAN_UNLIMITED'].indexOf(user.status) > -1"
                class="user-account-display-pro"
                size="15"
                color="softTextGrey"
              >
                mdi-earth
              </v-icon>
              <v-icon
                v-if="['PLAN_CUSTOM'].indexOf(user.status) > -1"
                class="user-account-display-custom"
                size="15"
                color="softTextGrey"
              >
                mdi-domain
              </v-icon>

              <!-- role -->
              <!-- <v-icon
                v-if="user.role === 'admin'"
                class="user-account-display-role-admin"
                size="18"
                color=" primary"
              >
                mdi-shield-crown-outline
              </v-icon>
              <v-icon
                v-if="user.role === 'tester'"
                class="user-account-display-role-tester"
                size="18"
                color=" primary"
              >
                mdi-head-minus-outline
              </v-icon> -->
            </v-list-item-title>
            <div class="items-flex ml-2">
              <span class="user-account-display-name-my-account">
                {{ $t(`drawer.title.myAccount`) }}
              </span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import userMixin from '@/views/components/core/userMixin.js'
import UserAvatar from '@/views/components/core/UserAvatar'

export default {
  name: 'DashboardCoreDrawer',
  components: { UserAvatar },
  mixins: [userMixin],
  data: () => ({
    items: [
      {
        title: 'portfolio',
        icon: 'mdi-wallet-travel',
        to: '/',
      },
      {
        icon: 'mdi-view-list',
        title: 'input',
        to: '/input',
      },
      {
        title: 'dashboardDetail',
        icon: 'mdi-chart-bar',
        to: '/detail',
      },
      {
        title: 'tax',
        icon: 'mdi-text-box-outline',
        to: '/tax',
      },
      {
        icon: 'mdi-folder-account-outline',
        title: 'netWorth',
        to: '/networth',
      },
      {
        icon: 'mdi-bullseye-arrow',
        title: 'watchList',
        to: '/watchlist',
      },
      // {
      //   icon: 'mdi-tooltip-question-outline',
      //   title: 'help',
      //   to: '/help',
      // },
    ],
  }),
  computed: {
    ...mapState(['user', 'supplantedUser']),
    miniVariant: {
      get() {
        return this.$store.state.miniVariant
      },
      set(val) {
        this.$store.commit('SET_MINIVARIANT', val)
      },
    },
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
  },
  watch: {
    '$route.path': {
      handler() {
        const path = this.$route.path
        this.items.forEach((item) => {
          if (!item.children) return
          if (item.children)
            this.$set(
              item,
              'active',
              item.children.some((child) => child.to === path)
            )
        })
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      setSupplantedUser: 'SET_SUPPLANTED_USER',
    }),
    async stopSupplantUser() {
      this.setSupplantedUser(undefined)

      if (this.$route && this.$route.name !== 'admin') {
        this.$router.replace({
          name: 'admin',
        })
      } else {
        location.reload()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/tools/_rtl.sass';

#core-navigation-drawer {
  height: 100% !important; // instead of 100vh, bug with append items
  .user-account {
    .user-account-avatar {
      margin-left: 3px;
    }
    .user-account-display-name {
      font-weight: 450;
      font-size: 14px;
    }
    .user-account-display-name-my-account {
      font-size: 13px;
      color: #999;
    }
    .user-account-display-premium {
      margin-bottom: 3px;
    }
    .user-account-display-pro {
      margin-bottom: 2px;
    }
    .user-account-display-custom {
      margin-bottom: 2px;
    }
    // .user-account-display-role-admin {
    //   margin-left: 3px;
    //   margin-bottom: 3px;
    // }
    // .user-account-display-role-tester {
    //   margin-left: 3px;
    //   margin-bottom: 1px;
    // }
  }

  .v-list-group__header {
    &.v-list-item--active {
      &::before {
        opacity: 0.25;
      }
      .v-list-item__title {
        font-weight: 400;
      }
    }
    .v-list-group__header__append-icon {
      margin-left: 0;
    }
  }

  .v-list-item {
    border-radius: 0;
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;

      @include ltr();
      margin-right: 24px;
      margin-left: 12px !important;

      @include rtl();
      margin-left: 24px;
      margin-right: 8px !important;
    }

    .v-list-item__title {
      font-weight: 400;
      color: #636363;
    }
  }

  .v-list-item__icon {
    i.v-icon {
      color: #999;
    }
  }

  .v-list-item:hover {
    .v-list-item__icon {
      i.v-icon {
        color: #636363;
      }
    }
    .v-list-item__title {
      color: #636363;
    }
  }

  .v-list-item--active {
    i.v-icon {
      color: #2597fe !important;
    }

    &::before {
      opacity: 0.9;
      border-radius: 0;
      border-left: 3px solid #2597fe;
      background-color: transparent;
    }
    .v-list-item__title {
      font-weight: 600;
      color: #2597fe !important;
    }

    .user-account-display-name-my-account {
      font-size: 13px;
      font-weight: 600;
      color: #2597fe;
    }
  }
  .v-list-item--link::before {
    background-color: transparent;
  }
  .v-list--dense {
    .v-list-item {
      &__icon--text,
      &__icon:first-child {
        margin-top: 10px;
      }
    }
  }
  .v-list-group--sub-group {
    .v-list-item {
      @include ltr();
      padding-left: 8px;

      @include rtl();
      padding-right: 8px;
    }
    .v-list-group__header {
      @include ltr();
      padding-right: 0;

      @include rtl();
      padding-right: 0;

      .v-list-item__icon--text {
        margin-top: 19px;
        order: 0;
      }
      .v-list-group__header__prepend-icon {
        order: 2;

        @include ltr();
        margin-right: 8px;

        @include rtl();
        margin-left: 8px;
      }
    }
  }

  .list-drawer-bottom {
    border-top: 1px solid #f7f8fb;
  }

  .theme--dark {
    .v-list-item__title {
      color: #a5a5a5;
    }

    .v-list-item:hover {
      .v-list-item__icon {
        i.v-icon {
          color: white;
        }
      }
      .v-list-item__title {
        color: white;
      }
    }

    &.list-drawer-bottom {
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
